
const CLEVER_CONFIG = {
    logo: 'https://cdn.re7.tech/partners/clever/favicon.svg',
    favicon: 'https://cdn.re7.tech/partners/clever/favicon.svg',
}

module.exports = { CLEVER_CONFIG }


